import { PremiumPlans } from 'components/organisms/premium/PremiumPlans'
import { MiteneIntlProvider } from 'components/providers/MiteneIntlProvider'
import { createRoot } from 'react-dom/client'
import './tailwind.css'

const node = document.getElementById('root')
const initialState = (window as any).INITIAL_STATE
const availablePlans = initialState?.availablePlans || []
const campaignEnabled = initialState?.campaignEnabled || false

if (node) {
  const root = createRoot(node)
  root.render(
    <MiteneIntlProvider>
      <PremiumPlans availablePlans={availablePlans} campaignEnabled={campaignEnabled} />
    </MiteneIntlProvider>,
  )
}
